<template>
    <div class="aside-right">
        <el-tooltip placement="left" effect="light">
            <div slot="content">
                <div class="alert-con alert-con1">
                    <el-image class="alert-img" :src="url1" :preview-src-list="[url1]">
                    </el-image>
                    <p>多媒体矩阵图</p>
                </div>
            </div>
            <div class="list">
                <img src="../../assets/imgs/fix1.png" alt="">
                <p>多媒体</p>
            </div>
        </el-tooltip>
        <el-tooltip placement="left" effect="light">
            <div slot="content">
                <div class="alert-con">
                    <el-image class="alert-img" :src="url2" :preview-src-list="[url2]">
                    </el-image>
                    <p>扫码联系客服</p>
                </div>
            </div>
            <div class="list">
                <img src="../../assets/imgs/fix2.png" alt="">
                <p>客服</p>
            </div>
        </el-tooltip>
        <el-tooltip placement="left" effect="light">
            <div slot="content">
                <div class="alert-con">
                    <p @click="copyFn('+61 2 8076 6493')"><b>电话: (+61) 2 8076 6493</b></p>
                </div>
            </div>
            <div class="list">
                <img src="../../assets/imgs/fix5.png" alt="">
                <p>电话</p>
            </div>
        </el-tooltip>
        <!-- <div class="list" @click="showAiFn">
            <img src="../../assets/imgs/fix6.png" alt="">
            <p>AI客服</p>
        </div> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            url1: require('../../assets/imgs/fix3.jpg'),
            url2: require('../../assets/imgs/fix4.jpg'),
        }
    },
    methods: {
        showAiFn() {
            this.$emit('showAiFn')
        },
        copyFn(text) {
            let input = document.createElement('input');
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success('复制成功')
        }
    },
}
</script>

<style lang="less" scoped>
.alert-con {
    width: 200px;
    height: auto;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px;

    .alert-img {
        width: 100%;
        height: auto;
        display: inline-block;
        margin: 0 auto;
    }

    p {
        font-size: 14px;
        color: #222222;
        text-align: center;
        padding-top: 10px;
    }
}

.alert-con1 {
    width: 350px;
}

.aside-right {
    position: fixed;
    right: 10px;
    bottom: 160px;
    z-index: 999;

    .list {
        width: 50px;
        height: 50px;
        border-radius: 6px;
        margin-bottom: 10px;
        text-align: center;
        cursor: pointer;
        // border: 1px solid #222222;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: .3s all;
        box-sizing: border-box;
    }

    .list:nth-of-type(1) {
        background-color: #a71103;
    }

    .list:nth-of-type(2) {
        background-color: #daa410;
    }

    .list:nth-of-type(3) {
        background-color: #05afb8;
    }

    .list:nth-of-type(4) {
        background-color: #05a82b;
    }

    img {
        width: 25px;
        height: auto;
    }

    p {
        font-size: 12px;
        color: #fff;
    }
}

@media (max-width: 899px) {

    .aside-right {
        bottom: 80px;
        right: 5px;

        .list {
            width: 45px;
            height: 45px;
            margin-bottom: 8px;
        }

        img {
            width: 22px;
        }

        p {
            font-size: 11px;
        }
    }

    .alert-con {
        width: 180px;
        padding: 8px;
    }

    .alert-con1 {
        width: 280px;
    }

    .alert-con p {
        font-size: 13px;
        padding-top: 8px;
    }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .aside-right {
        bottom: 70px;
        right: 3px;

        .list {
            width: 40px;
            height: 40px;
            margin-bottom: 6px;
        }

        img {
            width: 20px;
        }

        p {
            font-size: 10px;
        }
    }

    .alert-con {
        width: 160px;
        padding: 6px;
    }

    .alert-con1 {
        width: 240px;
    }

    .alert-con p {
        font-size: 12px;
        padding-top: 6px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/zh/fixRight.vue